module.exports = __webpack_public_path__ + "static/img/map_not_exist.895de0ba.svg";